// Ensamblado del homepage: las secciones que van DESPUÉS del hero, en orden.
// El hero (main.js) ocupa el riel sticky de 700vh; estas fluyen debajo y suben
// cuando el recorrido 3D termina. Se montan aquí, no en main.js, para mantener
// el hero desacoplado del resto de la página.
//
// Orden previsto del home: [hero] → (franja de confianza) → Julio → El Método →
// Podcast → Prueba → Suscripción → CTA. Se van agregando conforme se diseñan.
import './ds.css';   // tokens DS v2 (dark + variante .zk-light) — fuente única
// DOS SECCIONES SE ELIMINARON del home; sus módulos siguen en src/sections/
// por si hiciera falta recuperarlas:
//   · "Julio Pasos"  → lo absorbió el modal "Conoce a Julio" del hero.
//   · "El Método"    → lo absorbieron los BEATS del recorrido 3D, que ahora
//     llevan las tres variables, el beat del cero y el del 365, con el
//     lettering de la fórmula revelándose por tramos.
import { mountTestimonios } from './testimonios/testimonios.js';
import { mountPricing } from './pricing/pricing.js';
import { mountPodcast } from './podcast/podcast.js';
import { mountFooter } from './footer/footer.js';
import { mountQuees } from './quees/quees.js';
import { mountPordentro } from './pordentro/pordentro.js';

export function mountSections(root) {
  // Ritmo alternado D→L→D→L→D: Método → ¿Qué es Zenkai?(L) → Por dentro(D) → Testimonios(L) → Pricing.
  mountQuees(root);       // ¿Qué es Zenkai? (claro)
  mountPordentro(root);   // Por dentro de Zenkai (tour interactivo, oscuro)
  mountTestimonios(root);
  mountPricing(root);
  mountPodcast(root);
  mountFooter(root);      // siempre al final
}
